<template>
<v-container v-if="this.$store.getters.loaded == false">
    <v-overlay opacity="1" value="true">
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>
</v-container>

<v-container v-else class="py-5 pa-0 main-view">
  <div style="max-width: 800px;">
  <v-card class="mb-4">
    <v-card-item><v-card-title>Offline Spreadsheet</v-card-title></v-card-item>
    <v-card-text>
      Click the “Export” button to generate an Excel workbook containing all assessed controls, evidence, and other relevant data. Once downloaded, open and review the file to ensure accuracy, then upload it into your MyCSF account. This process transfers all verified audit information into the myCSF environment, allowing for seamless integration and further HITRUST activities.
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="exportWorkbook" :loading="exporting">
        Export
      </v-btn>
    </v-card-actions>
  </v-card>

  <v-card class="mb-4">
    <v-card-item><v-card-title>Test Plan</v-card-title></v-card-item>
    <v-card-text>
      Click the “Export” button to generate an Excel workbook detailing all sampled evidence requests, associated controls, and final test results. This export includes the sample sets chosen, the methods used to evaluate their effectiveness, and the resulting scores assigned by the assessor. Once you’ve downloaded the file, you can review or share it, and ultimately upload it into the myCSF portal to maintain a complete record of your HITRUST testing activities.
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="exportTP">
        Export
      </v-btn>
    </v-card-actions>
  </v-card>

  <v-card>
    <v-card-item>
      <v-card-title>Assessment Files</v-card-title>
      <v-card-subtitle>
        <div v-if="!downloadUrl">
          {{ fileComm }}
        </div>
        <div v-else>
          <a :href="downloadUrl" target="_blank">Click here to download your file</a>
        </div>
      </v-card-subtitle>
    </v-card-item>
    <v-card-text>
      Click the "Zip Files" button to compress all of the assessment files into a single ZIP file. You will get status updates during the compression process and when its done you will get a link to download the file. Unzip this file and upload these to MyCSF as appropriate.
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="downloadZip" :loading="zipLoading">
        Zip Files
      </v-btn>
    </v-card-actions>
  </v-card>

  </div>
</v-container>

</template>

<script>
import ExcelJS from 'exceljs';
import axios from "axios";
import { getFunctions, httpsCallable } from "firebase/functions";
import db from "@/main.js";
import {  doc, getDoc, setDoc } from "firebase/firestore";

// Base64 string of the image (example)
const logoBase64 = 'data:image/png;base64,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';

export default {
  name: 'Export',
  data() {
    return {
      currentProject: null,
      hasTransformed: false,
      exporting: false,
      fileStatus: null,
      downloadUrl: null,
      Inventory: [
            {"id": 1, "name": "01 Servers"},
            {"id": 2, "name": "02 Network Devices"},
            {"id": 3, "name": "03 SIEM"},
            {"id": 4, "name": "04 Wireless Access Points"},
            {"id": 5, "name": "05 VPN"},
            {"id": 6, "name": "06 Desktops"},
            {"id": 7, "name": "07 Facilities"},
            {"id": 8, "name": "08 Applications"},
            {"id": 9, "name": "09 Databases"},
            {"id": 10, "name": "10 Third Party Service Provid"},
            {"id": 11, "name": "11 Privileged Personnel"},
            {"id": 12, "name": "12 Personnel Newly Hired"},
            {"id": 13, "name": "13 Current Personnel"},
            {"id": 14, "name": "14 Personnel Terminated"},
            {"id": 15, "name": "15 Contractors"},
            {"id": 16, "name": "16 Remote Personnel"},
            {"id": 17, "name": "17 Non-Employees Terminated"},
            {"id": 18, "name": "18 IDSIPS"},
            {"id": 19, "name": "19 Dial-Up Servers"},
            {"id": 20, "name": "20 Incident Response"},
            {"id": 21, "name": "21 Change of Roles"},
            {"id": 22, "name": "22 Mobile Devices"},
            {"id": 23, "name": "23 Removable Media"},
            {"id": 24, "name": "24 BYOD"},
            {"id": 25, "name": "25 Collaborative Devices"},
            {"id": 26, "name": "26 Ethics Hotline Complaint"},
            {"id": 27, "name": "27 Commercial Products"},
            {"id": 28, "name": "28 System Changes"},
            {"id": 29, "name": "29 Asset Movement Status"},
            {"id": 30, "name": "30 Identified Vulnerabilities"},
            {"id": 31, "name": "31 System Connections"},
            {"id": 32, "name": "32 Network Service Provider"},
            {"id": 33, "name": "33 Sensitive Data "},
            {"id": 34, "name": "34 Password Reset Tickets"},
            {"id": 35, "name": "35 System Maintenance Records"},
            {"id": 36, "name": "36 Information Security Incid"},
            {"id": 37, "name": "37 Public Posting Staff"},
            {"id": 38, "name": "38 Transported Removable Medi"},
            {"id": 39, "name": "39 Key Management Personnel"},
            {"id": 40, "name": "40 Restricted Wireless Access"},
            {"id": 41, "name": "41 Application Changes"},
            {"id": 42, "name": "42 Database Changes"},
            {"id": 43, "name": "43 Configuration Changes"},
            {"id": 44, "name": "44 Network Device Changes"},
            {"id": 45, "name": "45 Operating System Changes"},
            {"id": 46, "name": "46 Vendor Supplied Software"},
            {"id": 47, "name": "47 Firewalls"},
            {"id": 48, "name": "48 Compromised Passwords"},
            {"id": 49, "name": "49 System Development"},
            {"id": 50, "name": "50 Vendors with Logical Acces"},
            {"id": 51, "name": "51 Data Exchange Agreements"},
            {"id": 52, "name": "52 Record Storage"},
            {"id": 53, "name": "53 IS Legal Incidents"},
            {"id": 54, "name": "54 Backup Records"},
            {"id": 55, "name": "55 Restoration Records"},
            {"id": 56, "name": "56 Sensitive Data Transmissio"},
            {"id": 57, "name": "57 Newly Purchased Assets"},
            {"id": 58, "name": "58 Interconnected Systems"},
            {"id": 59, "name": "59 E-Commerce Agreements"},
            {"id": 60, "name": "60 Seeded Accounts"},
            {"id": 61, "name": "61 System Accounts"},
            {"id": 62, "name": "62 Shared Accounts"},
            {"id": 63, "name": "63 Job Roles"},
            {"id": 64, "name": "64 Privileged Account Request"},
            {"id": 68, "name": "68 Outsourced Software Dev"},
            {"id": 70, "name": "70 Sensitive Applications"},
            {"id": 71, "name": "71 Sensitive Data"},
            {"id": 72, "name": "72 Third-party Users"},
            {"id": 73, "name": "73 Ethics Hotline Complaints"}
            ],
    };
  },
  methods: {

    test() {
        const fileUidMap = new Map();

        // Loop through all evidence objects
        this.$store.getters.allEvGetter.forEach(evidence => {
            if (evidence.ref && evidence.evray) {
                // Get the file name
                const fileName = evidence.ref;
                
                // Process each evidence request
                evidence.evray.forEach(evItem => {
                    // Get evidence request name (before the &)
                    const evRequestName = evItem.split('&')[0];
                    
                    // Get UIDs associated with this evidence request
                    const uids = this.$store.state.evMaster[this.currentProject][evRequestName]?.uids || [];
                    
                    // Get all UIDs
                    const uidValues = uids.map(uidObj => uidObj.uid);
                    
                    // Add or update file-UID mapping
                    if (fileUidMap.has(fileName)) {
                        const existingUids = fileUidMap.get(fileName);
                        fileUidMap.set(fileName, [...new Set([...existingUids, ...uidValues])]);
                    } else {
                        fileUidMap.set(fileName, uidValues);
                    }
                });
            }
        });

        //console.log(fileUidMap);
        // Loop through each entry in fileUidMap and log the fileName and each uidValue
        fileUidMap.forEach((uidValues, fileName) => {
            uidValues.forEach(uidValue => {
            console.log(`File Name: ${fileName}, UID Value: ${uidValue}`);
            });
        });

    },  
    async exportWorkbook() {
        console.log(this.$store.getters.allEvGetter)
      // Define the workbook structure
      const workbook = new ExcelJS.Workbook();

      // Define the sheets and headers
      const sheets = {
        Assessment: [
          "Requirement ID",
          "Domain Name",
          "Level",
          "Baseline Unique ID",
          "Requirement Provenance",
          "HITRUST CSF Requirement Statement",
          "Control Applicable",
          "Maturity - Implemented",
          "Maturity - Comments",
          "Assessor - Implemented Evaluation",
          "Unnamed: 10",
          "Assessor - General Comments",
          "Contact 1",
          "Contact Title 1",
          "Contact 2",
          "Contact Title 2",
          "Contact 3",
          "Contact Title 3",
          "Contact 4",
          "Contact Title 4",
          "Contact 5",
          "Contact Title 5",
        ],
        Documents: [
          "Document ID",
          "Document Name",
          "Description",
          "Document Type",
          "Third-Party Report?",
        ],
        "Requirement-Document Mapping": [
          "Baseline Unique ID",
          "Document Name",
          "Maturity Implemented Related?",
          "Mapping Type",
        ],
        Inheritance: [
          "Request ID",
          "Request Status",
          "Baseline Unique ID",
          "Inherited Assessment",
          "Weight (%)",
        ],
        "Fields-HiddenTab": [
          "Applicable",
          "Yes",
          "Assessor",
          5,
          10,
          "Maturity",
          "Managed",
          "DocumentType",
          "Mapping Type",
          "Third Party Report",
        ],
      };

        // Get docuMaster data and transform for Assessment sheet
        const docuMaster = this.$store.state.docuMaster[this.currentProject];
        const assessmentData = Object.keys(docuMaster).map(uidKey => {
            const uidObject = docuMaster[uidKey];
            return {
            "Requirement ID": "",
            "Domain Name": uidObject.dom,
            "Level": uidObject.level,
            "Baseline Unique ID": uidObject.uid,
            "Requirement Provenance": "i1 Core",
            "HITRUST CSF Requirement Statement": uidObject.req,
            "Control Applicable": uidObject.implscore === "NA" ? "No" : "Yes",
            "Maturity - Implemented": this.scoreXform(uidObject.implscore),
            "Maturity - Comments": "",
            "Assessor - Implemented Evaluation": "Assessor Agrees",
            "Unnamed: 10": null,
            "Assessor - General Comments": this.tResults(uidObject),
            "Contact 1": "",
            "Contact Title 1": "",
            "Contact 2": "",
            "Contact Title 2": "",
            "Contact 3": "",
            "Contact Title 3": "",
            "Contact 4": "",
            "Contact Title 4": "",
            "Contact 5": "",
            "Contact Title 5": "",
            };
        });


        // Create Documents sheet data
        const documentData = [];
        const seenDocuments = new Set(); // To track unique document names

        // Loop through evidence and collect unique document names
        this.$store.getters.allEvGetter.forEach(evidence => {
            if (evidence.ref && !seenDocuments.has(evidence.ref)) {
                seenDocuments.add(evidence.ref);
                documentData.push([
                    "", // Document ID
                    evidence.ref, // Document Name
                    "", // Description
                    "Subscriber Documents", // Document Type
                    "No" // Third-Party Report?
                ]);
            }
        });

        // Create Requirement-Document Mapping data
        const fileUidMap = new Map();
        this.$store.getters.allEvGetter.forEach(evidence => {
            if (evidence.ref && evidence.evray) {
            const fileName = evidence.ref;
            evidence.evray.forEach(evItem => {
                const evRequestName = evItem.split('&')[0];
                const uids = this.$store.state.evMaster[this.currentProject][evRequestName]?.uids || [];
                const uidValues = uids.map(uidObj => uidObj.uid);
                if (fileUidMap.has(fileName)) {
                const existingUids = fileUidMap.get(fileName);
                fileUidMap.set(fileName, [...new Set([...existingUids, ...uidValues])]);
                } else {
                fileUidMap.set(fileName, uidValues);
                }
            });
            }
        });

        const requirementDocumentMappingData = [];
        fileUidMap.forEach((uidValues, fileName) => {
            uidValues.forEach(uidValue => {
            requirementDocumentMappingData.push([
                uidValue, 
                fileName, 
                "True", 
                "Subscriber"
                ]);
            });
        });



      // Create each sheet and add it to the workbook
      for (const sheetName in sheets) {        
        const headers = sheets[sheetName];
        const worksheet = workbook.addWorksheet(sheetName);

        // Add headers
        worksheet.addRow(headers);

        // Style header row
        worksheet.getRow(1).eachCell((cell) => {
          cell.font = { name: 'Verdana', size: 12, color: { argb: 'FFFFFFFF' } };
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF6EA3CC' } };
          cell.alignment = { horizontal: 'left' };
        });

        // Add data based on sheet name
        if (sheetName === "Assessment") {
          assessmentData.forEach(row => {

            const newRow = worksheet.addRow(Object.values(row));      
            newRow.eachCell((cell, colNumber) => {
              cell.font = { name: 'Verdana', size: 11}; // Example: bold first column
              cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
              if (colNumber === 6) { 
                cell.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
              }

            }); 
          });
        }

        if (sheetName === "Documents") {
          documentData.forEach(row => {
            worksheet.addRow(row);
          });
        }

        if (sheetName === "Requirement-Document Mapping") {
          requirementDocumentMappingData.forEach(row => {
            worksheet.addRow(row);
          });
        }

        // Set column widths
        if (sheetName === "Assessment") {
          worksheet.columns = [
            { width: 15 },  // Requirement ID
            { width: 35 },  // Domain Name
            { width: 6 },   // Level
            { width: 40 },  // Baseline Unique ID
            { width: 10 },  // Requirement Provenance
            { width: 100 }, // HITRUST CSF Requirement Statement
            { width: 15 },  // Control Applicable
            { width: 30 },  // Maturity - Implemented
            { width: 30 },  // Maturity - Comments
            { width: 30 },  // Assessor - Implemented Evaluation
            { width: 15 },  // Unnamed: 10
            { width: 30 },  // Assessor - General Comments
            { width: 20 },  // Contact 1
            { width: 20 },  // Contact Title 1
            { width: 20 },  // Contact 2
            { width: 20 },  // Contact Title 2
            { width: 20 },  // Contact 3
            { width: 20 },  // Contact Title 3
            { width: 20 },  // Contact 4
            { width: 20 },  // Contact Title 4
            { width: 20 },  // Contact 5
            { width: 20 },  // Contact Title 5
          ];
        }

        if (sheetName === "Documents") {
          worksheet.columns = [
            { width: 15 },  // Document
            { width: 65 },  // Document Name
            { width: 10 },  // Description
            { width: 25 },  // Document Type
            { width: 20 },  // Third-Party Report?
          ];
        }

        if (sheetName === "Requirement-Document Mapping") {
          worksheet.columns = [
            { width: 35 },  // Baseline Unique ID
            { width: 65 },  // Document Name
            { width: 20 },  // Maturity Implemented Related?
            { width: 30 },  // Mapping Type
          ];
        }

      }

      // Export the workbook
      const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.projName + '-Offline-Workbook.xlsx';
        a.click();
        URL.revokeObjectURL(url);
    },
  async exportTP(){
      // Define the workbook structure
      const workbook = new ExcelJS.Workbook();

      // Define the sheets and headers
      const sheets = {
        "Lead Sheet": [
          "Population Type",
          "Total Population Size",
          "Sample Size",
          "Sampling Approach",
          "Sample Date Ranges",
          "Population Source",
          "Creation Date",
          "Notes",
        ],
        ...this.Inventory.reduce((acc, item) => {
          if (this.$store.state.InventoryData[item.id].na !== true) {
            // Truncate if needed
            const sheetName = item.name
            
            acc[sheetName] = [
                "TP ID",
                "Test Plan",
                "Test Results",
                "Scoring",
                "Filename(s) Used",
            ];
        }
        return acc;
        }, {}),

      };

      
        // Store sheet names
        const sheetNames = Object.keys(sheets);

      // Create each sheet and add it to the workbook
      for (const sheetName in sheets) {
        const headers = sheets[sheetName];
        const worksheet = workbook.addWorksheet(sheetName);



        // Add headers
        worksheet.addRow(headers);

        // Style header row
        const headerRow = worksheet.getRow(1);
        headerRow.eachCell((cell) => {
          cell.font = { name: 'Aptos Narrow', size: 14 , bold: true, color: { argb: '00000000' } };
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC0E6F5' } };          
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
          cell.border = {
                      top: { style: 'thin' },
                      left: { style: 'thin' },
                      bottom: { style: 'thin' },
                      right: { style: 'thin' }
                    };          
        });

        headerRow.height = 37; // Set the desired height

          // store.state.InventoryData

            // Add rows to "Lead Sheet"
        if (sheetName === "Lead Sheet") {
          const leadSheetData = [];

          Object.entries(this.$store.state.InventoryData).forEach(([key, value]) => {

            
            let populationType = this.Inventory.find(inv => inv.id == key)?.name || "";

            let totalPopulationSize = 0
            let sampleSize = 0

            Object.values(this.$store.state.allInventory).forEach(inventoryItem => {
              if (inventoryItem.inventory == key) {
                totalPopulationSize++;
              }
              if (inventoryItem.inventory == key && inventoryItem.selected == true) {
                sampleSize++;
              }              
            });
                        
            let samplingApproach = "Judgemental"
            if (value.rand == true){samplingApproach = "Random"}
            if (totalPopulationSize == sampleSize){samplingApproach = "Full"}


            let sampleDateRanges = this.formatDate(value.fdate) + " - " + this.formatDate(value.tdate)
            let populationSource = value.origin || ""
            let creationDate = this.formatDate(value.tdate)
            let notes = ""

            const row = [
              populationType,
              totalPopulationSize,
              sampleSize,
              samplingApproach,
              sampleDateRanges,
              populationSource,
              creationDate,
              notes,
            ];
            if (populationType !== "" && this.$store.state.InventoryData[key].na !== true) { 
              leadSheetData.push(row); 
            }
          });


          leadSheetData.forEach(row => {
            const newRow = worksheet.addRow(row);

            newRow.eachCell((cell, colNumber) => {
                    cell.font = { name: 'Arial', size: 10 }; // Example: bold first column
                    cell.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
                    cell.border = {
                      top: { style: 'thin' },
                      left: { style: 'thin' },
                      bottom: { style: 'thin' },
                      right: { style: 'thin' }
                    };
                    if (colNumber === 1) { // Example: specific formatting for the third column
                      cell.font = { bold: true, color: { argb: 'FF0B347D' } };
                      cell.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
                    }
                  });              

          });

          //Lead sheets column widths
          worksheet.columns = [
            { width: 33 },  // Population Type
            { width: 15 },  // Total Population Size
            { width: 15 },  // Sample Size
            { width: 25 },  // Sampling Approach
            { width: 25 },  // Sample Date Ranges
            { width: 30 },  // Population Source
            { width: 15 },  // Creation Date
            { width: 70 },  // Notes
          ];    
          
          //Lead sheet header row formatting
            headerRow.height = 65;
            headerRow.eachCell((cell) => {
            cell.font = { name: 'Arial', size: 11, bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF104861' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };
            });

          // Add image to "Lead Sheet"
        
          // Add image to workbook
          const imageId = workbook.addImage({
            base64: logoBase64.split(',')[1], // Remove the data URL prefix
            extension: 'png',
          });

          worksheet.addImage(imageId, {
            tl: { col: 7 + 0.1, row: 0 + 0.1}, // Column 8 (H), Row 1
            ext: { width: 163, height: 72 }, // Specify the width and height in pixels
            editAs: 'oneCell'
          });



        }


        //All sheets besides Lead Sheet
        if (sheetName !== "Lead Sheet") {
          worksheet.columns = [
            { width: 40 },  // TP ID
            { width: 40 },  // Test Plan
            { width: 45 },  // Test Results
            { width: 15 },  // Scoring
            { width: 30 },  // Filename(s) Used
            { width: 30 },  // Filename(s) Used
            { width: 30 },  // Filename(s) Used
            { width: 30 },  // Filename(s) Used
          ];
        }

      } 


        // Loop through this.Inventory and create variables based on the .id property
        this.Inventory.forEach(item => {
            const id = item.id
 

            // Find the specific sheet name that contains the item name
            const specificSheetName = sheetNames.find(name => name.includes(item.name));

            if (specificSheetName) {
                //console.log(`Found sheet: ${specificSheetName}`, "item name: "  + item.name);
                const specificSheet = workbook.getWorksheet(specificSheetName);
                if (!specificSheet) {
                  console.error(`Worksheet ${specificSheetName} not found`);
                  return;
                }

             
                Object.entries(this.$store.state.xformedInvObj).forEach(([key, item]) => {


                  let testResults = "No Test Results";
                  if(item.inventory == id) {

                    //break evidence request samples into rows and set the scores correctly taking into account NA  
                    if (item.samples && Object.keys(item.samples).length > 0) {
                      const results = [];                      
                      Object.values(item.samples).forEach(sample => {
                        let score = this.score2PF(sample.score);
                        if (sample.na == true) {score = "NA"}
                        
                        // Build result string
                        const resultString = `${sample.name}: ${score}`;
                        results.push(resultString);
                      });
                      // Join all results with newlines
                      testResults = results.join('\n');
                    }

                    //get files names
                    let fileNames = "";
                    if (item.files && item.files.length > 0) {
                      fileNames = item.files.join('\n');
                    }


                    const row = [
                      key,              // Now we have access to the key
                      item.description,
                      testResults,
                      item.na === true ? "NA" : `${item.score}%`,
                      fileNames,
                    ];

                    const newRow = specificSheet.addRow(row);

                    newRow.eachCell((cell, colNumber) => {
                    cell.font = { name: 'Arial', size: 10, bold: colNumber === 1 }; // Example: bold first column
                    cell.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
                    cell.border = {
                      top: { style: 'thin' },
                      left: { style: 'thin' },
                      bottom: { style: 'thin' },
                      right: { style: 'thin' }
                    };
                    if (colNumber === 4) { // Example: specific formatting for the third column
                      cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                    }
                  });                    

                  }
                });

            }

        });



    
      

      // Export the workbook
      const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.projName + '-Test-Plan.xlsx';
        a.click();
        URL.revokeObjectURL(url);   

    },

    async downloadZip() {
      this.downloadUrl = null
      this.$store.state.fileComm = "Starting ZIP process..."
      try {
        // Initialize Firebase Functions
        const functions = getFunctions();
        const downloadZip = httpsCallable(functions, 'downloadZip');



        // Call the Cloud Function with the projectId and userId
        const result = await downloadZip({ projectId: this.currentProject });

        // Get the download URL from the result
        const downloadUrl = result.data.downloadUrl;


      } catch (error) {
        console.error('Error downloading ZIP file:', error);
        // Handle errors here
      }
},
    scoreXform(score){
        if (score == "NA"){return "5. Fully Compliant (100%)"}
        const numScore = Number(score);
        if (score === 0){return "1. Non Compliant (0%)"}
        if (score === 25){return "2. Somewhat Compliant (25%)"}
        if (score === 50){return "3. Partially Compliant (50%)"}
        if (score === 75){return "4. Mostly Compliant (75%)"}
        if (score === 100){return "5. Fully Compliant (100%)"}
    },
    score2PF(score){
        if (score === 0){return "Fail"}
        if (score === 1){return "Fail"}
        if (score === 2){return "Pass"}
    },    
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp.seconds * 1000); // Convert seconds to milliseconds and create Date object
      const day = date.getDate();
      const month = date.getMonth() + 1; // Months are zero-based
      const year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
      return `${month}/${day}/${year}`;
    },   
    scoreAdjust(scorein){

      if (isNaN( scorein)){ return 0 }      
      if ( scorein >= 0 &&  scorein <= 10) { return 0 } //Very low
      if ( scorein >= 11 &&  scorein <= 32) { return 25 } //Low
      if ( scorein >= 33 &&  scorein <= 65) { return 50 } //Moderate
      if ( scorein >= 66 &&  scorein <= 89) { return 75 } //High
      if ( scorein >= 90 &&  scorein <= 100) { return 100 } //Very high

      return 0 

      },    
    tResults(currentObj){

      //console.log("tresult: ", currentObj)
      let totalScore = 0;
      let count = 0;
      let hundycount = 0;

      Object.keys(currentObj.elements).forEach(key => {
        if (currentObj.elements[key].score !== "NA" && !isNaN(currentObj.elements[key].score)) {
          totalScore += parseInt(currentObj.elements[key].score);
          count++;
          if (currentObj.elements[key].score == 100) {
            hundycount++;
          }
        }
      });

      let evidenceKeys = [];

      Object.keys(currentObj.elements).forEach(key => {
        if (currentObj.elements[key].evidence) {
          Object.keys(currentObj.elements[key].evidence).forEach(evidenceKey => {
            if (!evidenceKeys.includes(evidenceKey) && !evidenceKey.startsWith("HT-")) {
              evidenceKeys.push(evidenceKey);
            }
          });
        }
      });

      let finalScore = count === 0 ? 0 : this.scoreAdjust(Math.round(totalScore / count));    

      let exceptions = '\n\nNo exceptions noted'
      let evidence = ""
      let narrative = ""
      if (evidenceKeys.length > 0) {
        evidence = `\n\nRefer to sample testing performed in FD's test plan(s) at:\n${evidenceKeys.join('\n')}`;
      }
      if (currentObj.testnarrative ){narrative =  '\n\nAssessor Comment:\n' + currentObj.testnarrative}
      if (currentObj.implgaps){exceptions = `\n\nException(s) noted:\n${currentObj.implgaps}`}
      if (currentObj.implscore === "NA" ){ return `FD examined evidence to confirm that the requirement is Not Applicable.` }
      return `FD examined evidence for ${count} evaluative element(s) to confirm that the overall score is ${finalScore}%.${evidence}${narrative}${exceptions}`;
    }

  },
  beforeMount() {
          //A refresh happened and first data is not loaded yet.
          if (this.$store.getters.loaded == false){ this.$store.commit('beginLoading') }

          
          
          //get the current project id from the URL
          this.currentProject = this.$route.query.project
          this.$store.state.currentProject = this.$route.query.project



          //if project is already in store then load data to rows, if not then load database and wait for watcher
          if (this.currentProject in this.$store.state.loadedEvidence && this.$store.state.loadedEvidence[this.currentProject] == true ) {
            //Load data into table if project data was already loaded            
            this.rowData = this.$store.state.evMasterRay[this.currentProject]
            
            //Load title if project data was already loaded
            if (this.$store.state.initializing.projects == true){ document.title = "Vantage - Export - " + this.$store.state.projMasterObj[this.currentProject].name }
            } else {
            this.$store.dispatch('loadEvidence', { projid: this.currentProject })
            this.$store.dispatch('loadAllEvidence', { projid: this.currentProject })            
            }
          
          //load project UID data if its not loaded already
          if (this.currentProject in this.$store.state.loadedProjects && this.$store.state.loadedProjects[this.currentProject] == true ) {
            console.log('already loaded project UID data')
          } else {
            this.$store.dispatch('loadProject', { projid: this.currentProject })
          }

          //this.$store.dispatch('xformInventory', { projid: this.currentProject })

  },
  watch: {
    dataReady: {
      handler(newValue) {
        if (newValue && !this.hasTransformed) {
          this.hasTransformed = true;
          this.$store.dispatch('xformInventory', {
            projid: this.$store.state.currentProject
          });
        }
      },
      immediate: true
    },
    fileComm: {
    handler(newVal) {
      if (newVal && newVal.startsWith("Signed URL generated:")) {
        this.downloadUrl = newVal.substring(newVal.indexOf(':') + 1).trim();
      }
    },
    immediate: true
  }  
  },  
  computed: {
    dataReady() {
      return this.$store.state.evMaster && 
             this.$store.state.allEvMasterRay &&
             this.$store.state.currentProject &&
             this.$store.state.evMaster[this.$route.query.project] &&
             this.$store.state.allEvMasterRay[this.$route.query.project];
    },
    fileComm() {
     return this.$store.state.fileComm
    },
    projName() {
          if (this.$store.state.projMasterObj[this.$route.query.project]) {
              return this.$store.state.projMasterObj[this.$route.query.project].name;
          }
          return null; // or return an empty string "", or any other default value
      },
    zipLoading() {
      return this.$store.state.fileComm && !this.$store.state.fileComm.startsWith("Signed URL");
    },  
  },
  mounted() {},
};
</script>

<style scoped>
.export-page {
  padding: 20px;
}
</style>